<!-- Nyomkövetés. Egy kártya fogja a rendelés ÖSSZES küldeményét: a fő
     csomagot és minden csere csomagot. A support taskban fejléc nélkül,
     a kapcsolt rendelés alá ágyazva. -->
<!-- A rendelés oldalon akkor is látszik a kártya, ha még nincs küldemény:
     onnan lehet kézzel kódot rögzíteni. A support-változat üresen nem jelenik meg. -->
<div class="trk-card" *ngIf="!loading && !loadFailed && (shipments.length || !compact)"
     [class.trk-card--bare]="compact">

  <div class="trk-card__head" *ngIf="!compact" (click)="toggle()">
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#21252B" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="12" height="9" rx="1.5"></rect><path d="M14 10 h4 l3 3 v3 h-7"></path><circle cx="7" cy="18.5" r="1.7"></circle><circle cx="17" cy="18.5" r="1.7"></circle></svg>
    <h3 class="trk-card__title">Nyomkövetés</h3>
    <span class="trk-card__count" *ngIf="countLabel">{{ countLabel }}</span>
    <span class="trk-pill" [ngClass]="toneClass(summaryTone)">{{ summaryLabel }}</span>
    <span class="trk-card__chevron" [class.is-open]="open">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#707870" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6,9 12,15 18,9"></polyline></svg>
    </span>
  </div>

  <div class="trk-card__body" *ngIf="open || compact">

    <!-- Küldeményenként: fő csomag, majd a csere csomagok sorszám szerint. -->
    <div class="trk-ship" *ngFor="let row of shipments; let first = first"
         [class.trk-ship--first]="first">

      <!-- A megnevezés csak akkor kell, ha több küldemény van — egy csomagnál
           a „Fő csomag" felirat fölösleges zaj. -->
      <div class="trk-ship__head" *ngIf="shipments.length > 1 || row.view.kind === 'replacement'">
        <span class="trk-ship__title">{{ row.view.title }}</span>
        <span class="trk-pill" [ngClass]="toneClass(row.view.tone)">{{ row.view.statusLabel }}</span>
      </div>

      <div class="trk-alert" *ngIf="row.view.stalled">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#A14D4D" stroke-width="2.2" stroke-linecap="round"><path d="M12 4 L21 19 H3 Z"></path><line x1="12" y1="10" x2="12" y2="14"></line><circle cx="12" cy="16.6" r="0.5" fill="#A14D4D"></circle></svg>
        <span>{{ row.view.stalledDays }} napja nem mozdult. Érdemes megkeresni a futárt.</span>
      </div>

      <!-- Egy küldeménynél az állapot itt kap helyet (nincs küldemény-fejléc). -->
      <div class="trk-meta" *ngIf="shipments.length === 1 && row.view.kind === 'main' && compact">
        <span class="trk-meta__k">Nyomkövetés</span>
        <span class="trk-pill" [ngClass]="toneClass(row.view.tone)">{{ row.view.statusLabel }}</span>
      </div>

      <div class="trk-meta" *ngIf="row.view.carrierName">
        <span class="trk-meta__k">Futár</span>
        <span class="trk-meta__v">{{ row.view.carrierName }}</span>
      </div>

      <div class="trk-meta">
        <span class="trk-meta__k">Küldeménykód</span>
        <a *ngIf="row.view.trackingUrl" class="trk-meta__v trk-code" [href]="row.view.trackingUrl"
           target="_blank" rel="noopener">{{ row.view.trackingCode }} ↗</a>
        <span *ngIf="!row.view.trackingUrl" class="trk-meta__v trk-code">{{ row.view.trackingCode }}</span>
      </div>

      <div class="trk-meta" *ngIf="row.transitLabel">
        <span class="trk-meta__k">{{ row.view.deliveredAt ? 'Feladva → érkezett' : 'Feladva' }}</span>
        <span class="trk-meta__v" [class.trk-meta__v--warn]="row.view.stalled">{{ row.transitLabel }}</span>
      </div>

      <ul class="trk-timeline" *ngIf="row.events.length">
        <li *ngFor="let e of row.events; let firstEvent = first"
            [class.is-now]="firstEvent && !e.alert" [class.is-alert]="e.alert">
          <span class="trk-timeline__dot"></span>
          <div class="trk-timeline__txt">{{ e.event.label }}</div>
          <div class="trk-timeline__sub" *ngIf="e.event.location">{{ e.event.location }}</div>
          <div class="trk-timeline__sub trk-timeline__sub--orig" *ngIf="e.event.description && e.event.description !== e.event.label" [title]="e.event.description">{{ e.event.description }}</div>
          <div class="trk-timeline__time">{{ e.timeLabel }}</div>
        </li>
      </ul>

      <div class="trk-empty" *ngIf="!row.events.length">
        A küldeménykód rögzítve, de a futár még nem jelentett eseményt.
      </div>

      <!-- A lekérdezés hibája nem tűnhet el némán: a support ebből tudja meg,
           hogy a panel nem elavult adatot mutat, hanem el sem érte a futárt. -->
      <div class="trk-error" *ngIf="row.view.pollError">
        A nyomkövetés frissítése nem sikerült: {{ row.view.pollError }}
      </div>

      <div class="trk-foot">
        <span class="trk-foot__note" *ngIf="row.updatedLabel">Frissítve {{ row.updatedLabel }}<ng-container *ngIf="row.view.source"> · {{ row.view.source }}</ng-container></span>
        <button type="button" class="trk-foot__more" *ngIf="row.hiddenEvents > 0" (click)="showAll()">
          Teljes előzmény (+{{ row.hiddenEvents }})
        </button>
        <button type="button" class="trk-foot__refresh" *ngIf="!compact && first"
                [disabled]="refreshing" (click)="refresh($event)">
          {{ refreshing ? 'Frissítés…' : 'Frissítés' }}
        </button>
      </div>

    </div>

    <!-- Kézi kódrögzítés: UPS / Foxpost / Spring papíron feladott csomaghoz. -->
    <div class="trk-manual" *ngIf="!compact" [class.trk-manual--first]="!shipments.length">
      <button type="button" class="trk-manual__toggle" *ngIf="!manualOpen" (click)="toggleManual($event)">
        + Küldeménykód kézi rögzítése
      </button>
      <form class="trk-manual__form" *ngIf="manualOpen" (ngSubmit)="saveManual()">
        <input class="trk-manual__input" type="text" name="manualCode" [(ngModel)]="manualCode"
               placeholder="Küldeménykód (pl. 1Z… vagy CLFOX…)" maxlength="64" autocomplete="off"
               [disabled]="manualSaving">
        <select class="trk-manual__select" name="manualCarrier" [(ngModel)]="manualCarrier" [disabled]="manualSaving">
          <option *ngFor="let c of carrierOptions" [value]="c.value">{{ c.label }}</option>
        </select>
        <div class="trk-manual__actions">
          <button type="submit" class="trk-manual__save" [disabled]="manualSaving || !manualCode.trim()">
            {{ manualSaving ? 'Mentés…' : 'Rögzítés' }}
          </button>
          <button type="button" class="trk-manual__cancel" [disabled]="manualSaving" (click)="toggleManual($event)">Mégse</button>
        </div>
        <div class="trk-error" *ngIf="manualError">{{ manualError }}</div>
        <div class="trk-manual__hint">A futárt a kódból ismeri fel a rendszer; ha nem egyértelmű, válaszd ki.</div>
      </form>
    </div>
  </div>
</div>
